import { Icon, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Paper, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DeleteTitleDialogProps as Props } from './types';

export const DeleteTitleDialog = memo(
  ({ className, name, type, description }: Props) => {
    const companyType = type?.includes('COMPANY');
    const color = companyType ? 'primary.500' : 'success.600';

    return (
      <Styled.Wrapper
        className={classnames('DeleteTitleDialog', className)}
        sx={SX.root}
      >
        <Typography variant="body3" fontWeight={600} color="grey.800">
          Just checking — are you sure you want to delete this?
        </Typography>
        {description ? (
          <Typography variant="body3" color="grey.700" fontWeight={400}>
            {description}
          </Typography>
        ) : (
          <Paper variant="outlined" sx={SX.card}>
            <Box sx={SX.leftSide}>
              <Icon
                name={companyType ? 'business' : 'people-outline'}
                color={color}
                size={18}
              />
            </Box>
            <TextEllipsis variant="body3" color="grey.800" fontWeight={600}>
              {name}
            </TextEllipsis>
          </Paper>
        )}
      </Styled.Wrapper>
    );
  }
);

DeleteTitleDialog.displayName = 'DeleteTitleDialog';
